<template>
  <div @click.stop.prevent="close" class="modal-back">
    <div @click.stop class="modal-inner">
      <div class="wrapper" :class="{'image-wrapper': contentKind === 'image', 'url-wrapper': contentKind === 'url'}">
        <div
          class="close-btn"
          @click="close"
          data-shortcut-esc="imageUploadPopup"
        >
          <span></span>
        </div>
        <ul class="nav-tab" v-if="isShowTabPanel">
          <li @click="onChangeContentKind('image')" :class="{ selected: contentKind === 'image' }" class="image">
            イメージ登録
          </li>
          <li @click="onChangeContentKind('url')" :class="{ selected: contentKind === 'url' }" class="url">
            URL指定
          </li>
          <li class="underline"></li>
        </ul>
        <div v-if="contentKind === 'url'" class="preview-thumbnail-wrapper">
          <div class="thumbnail thumbnail-small">
            <template v-if="isPreviewExternalImage">
              <img :src="previewExternalUrl">
            </template>
            <template v-else>
              <span class="url-preview-info">( 画像プレビュー表示領域 )</span>
            </template>
          </div>
        </div>
        <div v-else-if="file && dataUrl" class="thumbnail">
          <img :src="dataUrl">
        </div>
        <div v-else>
          <vue-dropzone
            ref="myVueDropzone"
            :options="dropzoneOptions"
            id="custom-dropzone"
            @vdropzone-file-added="fileAdded"
            @vdropzone-thumbnail="thumbnailCreated"
            :useCustomSlot="true"
          >
            <div class="dropzone-custom-content">
              <p class="dropzone-custom-title">ここに画像をドロップ<br><span>または</span></p>
              <span>ファイル選択</span>
            </div>
          </vue-dropzone>
        </div>
      </div>
      <div class="input-area">
        <div>
          <template v-if="isMultiUpload">
            <div class="scroll-box">
              <ul>
                <li v-for="(filename, index) in filenames" :key="index">
                  <span @click="removeFile(index)" class="times-circle"><i class="fas fa-times-circle"></i></span><span>{{filename}}</span>
                </li>
              </ul>
            </div>
            <div>
              <label class="group-label">グループ</label>
              <div
                class="common-select group-select group-select-multiple-image"
                :style="(isLogo || contentKind === 'url') ? {visibility: 'hidden'} : null"
              >
                <select @input="addFolder($event.target.value)">
                  <option v-for="(folder, index) in folders.data" :key="index" :value="folder.id">
                    {{ folder.name }}
                  </option>
                </select>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="image-inputarea">
              <template v-if="contentKind === 'url'">
                <fieldset class="url">
                  <label>参照URL</label>
                  <div class="url-preview-input">
                    <input
                      type="text"
                      v-model="form.url"
                      ref="imageUrlInput"
                      @keydown.enter="$utils.event.strictEnter($event, previewImageURL)"
                    />
                    <button @click="previewImageURL">プレビュー</button>
                  </div>
                </fieldset>
              </template>
              <fieldset class="image">
                <label>画像名</label>
                <input
                  type="text"
                  v-model="form.name"
                >
              </fieldset>
              <fieldset class="alt">
                <label>altテキスト</label>
                <input
                  type="text"
                  v-model="form.alt"
                >
              </fieldset>
              <fieldset
                class="group"
                :style="(isLogo || contentKind === 'url') ? {visibility: 'hidden'} : null"
              >
                <label>グループ</label>
                <div
                  class="common-select group-select"
                >
                  <select @input="addFolder($event.target.value)">
                    <option v-for="(folder, index) in folders.data" :key="index" :value="folder.id">
                      {{ folder.name }}
                    </option>
                  </select>
                </div>
              </fieldset>
            </div>
          </template>
        </div>
        <button class="submit" @click="contentKind === 'url' ? insertImageURL() : upload()">登録</button>
        <div class="loading" v-if="isLoading">
          <div class="spinner">
            <span>Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import constants from '@/constants'
import { mixin as onClickAway } from 'vue-clickaway'
import ShortCutBase from '@/mixins/ShortCutBase'
import { validateImageUrl, validateImageFilename, validateImageAlt } from '@/utils/String'

const MAX_FILES_COUNT = 20

export default {
  components: {
    VueDropzone: Vue2Dropzone,
  },
  props: {
    isCallByEditor: {
      type: Boolean,
    },
    isLogo: {
      type: Boolean,
    },
    isMultiUpload: {
      type: Boolean,
    },
    isShowTabPanel: {
      type: Boolean,
      default: false,
    },
    ids: {
      type: Object,
    }
  },
  mixins: [
    onClickAway,
    ShortCutBase,
  ],
  data () {
    return {
      form: {
        name: '',
        alt: '',
        beforeKindName: '',
        beforeKindAlt: '',
        url: null,
      },
      contentKind: 'image',
      isLoading: false,
      isPreviewExternalImage: false,
      previewExternalUrl: null,
      formData: new FormData(),
      filenames: [],
      dataUrl: null,
      file: null,
      dropzoneOptions: {
        thumbnailWidth: 200,
        maxFilesize: constants.uploadMaxSizeMB,
        maxThumbnailFilesize: constants.uploadMaxSizeMB,
        url: 'required',
        dictDefaultMessage: 'ここにファイルをドロップしてアップロード',
        acceptedFiles: '.png, .jpeg, .jpg, .gif',
        autoProcessQueue: false,
      },
      folders: {
        data: [],
        select: 'unset', // 'unset' or int
        addOption: false,
      },
    }
  },
  computed: {
    isExternalImage () {
      return this.isShowTabPanel && this.contentKind === 'url'
    }
  },
  created () {
    if (this.isMultiUpload) {
      this.dropzoneOptions.createImageThumbnails = false
      this.dropzoneOptions.maxFiles = MAX_FILES_COUNT
    } else {
      this.dropzoneOptions.createImageThumbnails = true
      this.dropzoneOptions.maxFiles = 1
    }
  },
  mounted () {
    // 一度だけformDataに入れる
    this.formData.append('uploadPlaces[]', 'origin')
    // エディターから呼ばれた場合
    if (this.isCallByEditor) {
      this.formData.append('contentId', this.$route.params.id)
      this.formData.append('uploadPlaces[]', 'content')
    }
    // ロゴの時はグループは読み込まない
    !this.isLogo && this.getFolders()
  },
  methods: {
    getFolders () {
      return this.$http({
        url: `/folder/image?sortTarget=manual&sortType=asc`,
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          this.folders.data = [
            {
              id: 'unset',
              name: '未設定',
            },
            ...json.data.folders.map(folder => {
              return {
                ...folder,
                name: this.$utils.string.b64Decode(folder.name),
              }
            })
          ]
        }
      })
    },
    removeFile (index) {
      const files = this.formData.getAll('files[]')
      const alts = this.formData.getAll('alts[]')
      this.formData.delete('files[]')
      this.formData.delete('alts[]')
      delete files[index]
      delete alts[index]
      this.filenames = []
      files.forEach(file => this.fileAdded(file, true))
    },
    fileAdded (file, isFromRemoveFile = false) {
      if (constants.uploadMaxSizeMB * 1000 * 1000 < file.size) { // バリデーション時だけMiBではなくMBで計算する
        const displaySizeKB = Math.floor(file.size / 1024).toLocaleString()
        this.$store.commit('showErrorMessagePopup', [`${file.name}(${displaySizeKB}KB)は`, `アップロード可能サイズ(${constants.uploadMaxSizeMB}MB)を超えています`])
        return
      }

      if (this.isMultiUpload) {
        if (this.dropzoneOptions.maxFiles <= this.formData.getAll('files[]').length) {
          return this.$store.commit('showErrorMessagePopup', ['一度に登録できる画像は' + MAX_FILES_COUNT + '個までです'])
        }
        // 複数
        if (isFromRemoveFile) {
          // ファイル削除から来た場合、ファイル名はエンコード済み
          this.formData.append('files[]', file, file.name)
          this.filenames.push(this.$utils.string.fileNameDecode(file.name))
        } else {
          this.formData.append('files[]', file, this.$utils.string.fileNameEncode(file.name))
          this.filenames.push(file.name)
        }
      } else {
        if (this.file) {
          this.$store.commit('showErrorMessagePopup', ['複数のアップロードは「複数アップロード」をご利用ください'])
          this.$emit('close')
          return
        }
        // 単数
        // 入力フォーム初期値をセット
        this.form.name = String(this.form.name) || file.name
        if (this.form.alt) this.form.alt = String(this.form.alt)

        this.file = file
      }
    },
    addFolder (folderID) {
      const folder = this.folders.data.find(folder => {
        return folder.id === Number(folderID)
      })
      this.folders.select = folder ? folder.id : 'unset'
    },
    thumbnailCreated (file, dataUrl) {
      this.dataUrl = dataUrl
    },
    upload () {
      // ダブルクリック防止
      if (this.isLoading) return

      if (!(this.file || this.formData.has('files[]'))) {
        return this.$store.commit('showErrorMessagePopup', ['画像が選択されていません'])
      }
      if (!this.isMultiUpload) {
        // 単数
        if (!this.form.name) {
          return this.$store.commit('showErrorMessagePopup', ['画像名が入力されていません'])
        }
        this.formData.append('files[]', this.file, this.$utils.string.fileNameEncode(this.form.name))
        this.formData.append('alts[]', this.$utils.string.b64Encode(this.form.alt))
        this.formData.append('flgLogo', this.isLogo ? 1 : 0)
        if (this.isCallByEditor) {
          this.formData.append('tmpUuid', this.$store.state.contentTmpUuid)
        }
      }
      this.formData.append('folder', this.folders.select)
      this.isLoading = true
      this.$http({
        url: '/image/upload',
        type: 'POST',
        params: this.formData
      }).then(json => {
        this.isLoading = false
        if (json && json.status === 200) {
          const images = json.data.images.map(image => {
            return {
              ...image,
              url: decodeURIComponent(image.url),
              thumbnailUrl: decodeURIComponent(image.thumbnailUrl),
            }
          })
          this.$store.commit('mergeImages', images)
          this.$emit('updateCurrentSize', json.data.current_size)
          this.$emit('updatePlanSize', json.data.plan_size)
          // エディターから呼ばれた場合
          if (this.isCallByEditor) {
            this.$emit('reflectImage', {
              image: images[0],
              isDetailEditor: false,
            })
            this.$store.commit('mergeContentImages', { [images[0].key]: images[0] })
          }
          this.close()
        } else {
          // 失敗時
          if (!this.isMultiUpload) {
            // 一部formDataを空にする
            this.formData.delete('files[]')
            this.formData.delete('alts[]')
          }
        }
      })
    },
    close () {
      // 処理中は閉じないように
      if (this.isLoading) return

      this.dataUrl = null
      this.file = null
      this.form = { name: '', alt: '' }
      this.$emit('close')
    },
    addFolderHidden () {
      this.folders.addOption = false
    },
    checkImageURL (url, filename, alt) {
      const errorMessages = [
        ...validateImageUrl(url),
        ...validateImageFilename(filename),
        ...validateImageAlt(alt)
      ]
      return errorMessages
    },
    async fetchImageURL () {
      this.isLoading = true
      const url = this.$refs['imageUrlInput'].value
      const formData = new FormData()
      formData.append('url', this.$utils.string.b64Encode(url))
      formData.append('tmpUuid', this.$store.state.contentTmpUuid)
      formData.append('contentId', this.$route.params.id)
      const result = await this.$http({
        url: '/image/check_external_image',
        type: 'POST',
        params: formData,
      }).then(json => {
        if (json && json.status === 200) {
          return json.data.image
        }
        return undefined
      })
      this.isLoading = false
      return result
    },
    async previewImageURL () {
      const url = this.$refs['imageUrlInput'].value
      const errorMessages = validateImageUrl(url)
      if (errorMessages.length > 0) {
        this.$store.commit('showErrorMessagePopup', errorMessages)
        return
      }
      const image = await this.fetchImageURL()
      if (image) {
        this.isPreviewExternalImage = true
        this.previewExternalUrl = url
        if (this.form.name === '') {
          // 画像名が未入力の場合 ファイル名を挿入する
          this.form.name = this.$utils.string.getStrippedImageFilename(image.filename)
        }
      } else {
        this.isPreviewExternalImage = false
      }
      return image
    },
    async insertImageURL () {
      const url = this.$refs['imageUrlInput'].value
      const errorMessages = this.checkImageURL(url, this.form.name, this.form.alt)
      if (errorMessages.length > 0) {
        this.$store.commit('showErrorMessagePopup', errorMessages)
        this.isLoading = false
        return
      }
      const image = await this.previewImageURL()
      if (image) {
        image.filename = String(this.form.name) || this.$utils.string.getStrippedImageFilename(image.filename)
        this.$emit('reflectImage', {
          image: {
            ...image,
            filename: image.filename,
            'data-external-url': image.url,
            alt: this.$utils.string.sanitizeEncode(String(this.form.alt)),
          },
          isDetailEditor: false,
        })
        this.$store.commit('mergeContentImages', { [image.key]: image })
        this.$emit('close')
      }
    },
    onChangeContentKind (kindName = 'image') {
      // 変わる前のタブの form の値を変数で保持しておく
      const beforeKindName = this.form.name
      const beforeKindAlt = this.form.alt
      // 変わる前のタブの値を保持している data をフォームに反映
      this.form.name = this.form.beforeKindName
      this.form.alt = this.form.beforeKindAlt
      // 変わる前のタブの form の値を、data に保持しておく
      this.form.beforeKindName = beforeKindName
      this.form.beforeKindAlt = beforeKindAlt
      // タブを切り替えるために、 data を更新
      this.contentKind = kindName
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-inner {
  padding: 5px;
  width: 520px;
  background-color: #F8F8F8;
  border-radius: 2px;
  position: relative;
  .close-btn {
    position: absolute;
    display: inline-block;
    width: 50px;
    height: 50px;
    top: 3px;
    right: 3px;
    border: none;
    cursor: pointer;
    background: none;
    outline: none;
    span::before, span::after {
      display: block;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 25px;
      height: 3px;
      border-radius: 2px;
      margin: -1px 0 0 -13px;
      background: #000;
    }
    span::before {
      transform: rotate(-45deg);
    }
    span::after {
      transform: rotate(45deg);
    }
    &:hover {
      opacity: 0.7;
    }
  }
}
.wrapper {
  width: 378px;
  margin: 26px auto 20px;
  &.url-wrapper {
    margin-bottom: 12px;
  }
  .thumbnail {
    margin: 0 auto;
    text-align: center;
    width: 230px;
    height: 230px;
    padding: 5px;
    img {
      margin: auto;
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      padding: 5px;
    }
  }
  .preview-thumbnail-wrapper {
    border: 1px solid #d1d1d1;
  }
  .thumbnail-small {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 180px;
    .url-preview-info {
      font-size: 14px;
      color: #d1d1d1;
    }
    img {
      padding-top: 0px;
      padding-bottom: 0px;
    }
  }
}

.nav-tab {
  position: relative;
  display: inline-block;
  text-align: center;
  margin-bottom: 10px;
  cursor: pointer;
  user-select:none;
  width: 100%;
  li {
    display: inline-block;
    color: #A7A7A7;
    background: #f8f8f8;
    height: 40px;
    line-height: 40px;
    border-bottom: #dbdbdb 0.5px solid;
    font-size: 18px;
    width: 50%;
    a {
      color: #A7A7A7;
      display: block;
    }
    &.selected, &:hover, a:hover {
      color: $commonFontColor;
    }
    &.selected {
      border: none;
      ~ .underline {
        width: 50%;
        height: 1.5px;
        background: #707070;
        position: absolute;
        bottom: -1.5px;
        transition: all 0.2s ease-in-out 0s;
        border: none;
        left: 0px;
      }
    }
    &.image {
      &.selected {
        ~ .underline {
          left: 0%;
        }
      }
    }
    &.url.selected {
      ~ .underline {
        left: 50%;
      }
    }
  }
}
</style>
<style lang='scss'>
#custom-dropzone {
  background-color: #f8f8f8;
  border-radius: 2px;
  border: 1px dashed rgb(209, 209, 209);
  font-family: 'Arial', sans-serif;
  letter-spacing: 0.2px;
  color: #777;
  transition: background-color .2s linear;
  height: 244px;
  cursor: pointer;
  .dropzone-custom-content {
    color: #c4c4c4;
    .dropzone-custom-title {
      span {
        font-size: 12px;
        padding-top: 5px;
      }
      &::before {
        display: block;
        font-size: 65px;
        content: '\f574';
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
      }
    }
    > span {
      background: #fff;
      padding: 8px 15px;
      border-radius: 5px;
    }
  }
  .dz-preview {
    width: 160px;
    display: inline-block;
    .dz-image {
      width: 80px;
      height: 80px;
      margin-left: 40px;
      margin-bottom: 10px;
      > div {
        width: inherit;
        height: inherit;
      }
      > img {
        width: 100%;
      }
    }
    .dz-details {
      color: white;
      transition: opacity .2s linear;
      text-align: center;
    }
  }
  .dz-message {
    display: block;
    text-align: center;
    margin: 0;
  }
  .dz-preview {
    display: none;
  }
  .dz-success-mark, .dz-error-mark {
    display: none;
  }
}
.input-area {
  width: 400px;
  margin: 0 auto;
  color: $commonFontColor;
  .image-inputarea {
    width: 300px;
    margin: 0 auto
  }
  .image, .alt, .url, .group {
    font-size: 14px;
    label {
      display: block;
      margin:10px 0 0 0;
      &::before {
        padding-right: 8px;
        font-size: 14px;
        font-family: "Font Awesome 5 Free";
      }
    }
    input {
      width: 300px;
      height: 28px;
      line-height: 28px;
      border-radius: 2px;
      background: #e4e4e4;
      padding: 0 10px;
      box-sizing: border-box;
    }
  }
  .group {
    label {
      &::before {
        content: '\f5fd';
        font-weight: 900;
      }
    }
  }
  .url {
    .url-preview-input {
      position: relative;
    }
    button {
      position: absolute;
      height: 100%;
      width: 80px;
      font-size: 12px;
      border: solid 1px #c6c6c6;
      cursor: pointer;
      border-radius: 5px;
    }
    label {
      &::before {
        content: '\f15c';
      }
    }
  }
  .image {
    label {
      &::before {
        content: '\f03e';
      }
    }
  }
  .alt {
    label {
      &::before {
        content: '\f304';
        font-weight: 900;
      }
    }
  }
  .scroll-box {
    overflow-y: auto;
    overflow-x: hidden;
    height: 165px;
    width: 400px;
    font-size: 14px;
    margin-bottom: 15px;
    .times-circle {
      padding-right: 8px;
    }
  }
  .group-select {
    width: 100%;
    margin-bottom: 13px;
    &-multiple-image {
      max-width: 75%;
      margin-left: 12.5%;
    }
  }
  .group-label {
    display: block;
    padding-left: 12.5%;
    &::before {
      padding-right: 8px;
      font-size: 14px;
      font-family: "Font Awesome 5 Free";
      content: '\f5fd';
      font-weight: 900;
    }
  }
  .submit {
    color: #fff;
    border: solid 1px #484848;
    background: #484848;
    border-radius: 5px;
    position: absolute;
    bottom: 30px;
    right: 20px;
    font-size: 14px;
    padding: 2px 20px;
    cursor: pointer;
    &:hover {
      background: #484848;
      opacity: 0.8;
    }
  }
  .loading {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    top: 0;
    left: 0;
  }
}
</style>
